import RowCheckController from "./row_check_controller";

export default class extends RowCheckController {

  editMultipleOrders(event){
    const transitionAction = event.target.dataset.transitionAction
    const urlValue = event.target.dataset.urlValue
    const redirectPath = event.target.dataset.redirectPath
    const params = `?orders=${[...this.checkedIds]}&transition_action=${transitionAction}&redirect_to=${redirectPath}`
    fetch(`${urlValue}${params}`, {
      headers: {
        accept:
          "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
      },
    }).then(response => {
      if (response.redirected) {
          window.location.href = response.url;
      }
    })
  }
}
